/*
 * Advertorial PDP buy box.
 * Standalone: only runs inside <lr-adv-buybox> (sections/main-advertorial-pdp.liquid).
 */
(function () {
  if (window.customElements.get('lr-adv-buybox')) return;

  const lines = (text) => (text || '').split(/\r?\n/).map((l) => l.trim()).filter(Boolean);
  const toMap = (text) => {
    const map = {};
    lines(text).forEach((l) => {
      const i = l.indexOf('|');
      if (i > 0) map[l.slice(0, i).trim().toLowerCase()] = l.slice(i + 1).trim();
    });
    return map;
  };
  const cleanName = (name) => String(name).replace(/\*[^*]*\*/g, '').trim();
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  class LrAdvBuybox extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      this.cfg = JSON.parse(this.querySelector('[data-lr-adv-config]').textContent);
      const cfg = this.cfg;

      this.colors = toMap(cfg.scentColors);
      this.notes = toMap(cfg.scentNotes);
      this.sampleOptions = lines(cfg.sampleOptions);
      this.surprise = lines(cfg.surprisePicks).slice(0, cfg.sampleCount);
      this.count = cfg.sampleCount;
      this.variants = cfg.variants.map((v) => ({ ...v, scent: cleanName(v.name), seasonal: /seasonal/i.test(v.name) }));
      this.plans = cfg.plans.map((p) => {
        const m = String(p.label).match(/(\d+)\s*week/i);
        return { ...p, weeks: m ? Number(m[1]) : null };
      });
      this.hasPlans = this.plans.length > 0 && this.variants.some((v) => Object.keys(v.allocs).length);

      const current = this.variants.find((v) => v.id === cfg.currentVariantId);
      this.variantId = (current || this.variants.find((v) => v.available) || this.variants[0]).id;
      const defaultPlan = this.plans.find((p) => String(p.weeks) === String(cfg.defaultWeeks)) || this.plans[0];
      this.planId = defaultPlan ? defaultPlan.id : null;
      this.type = this.hasPlans ? 'sub' : 'once';
      this.mode = 'surprise';
      this.picks = this.surprise.slice();
      this.qty = 1;
      this.giftIds = [cfg.sampleGift.variantId, cfg.smallGift.variantId].filter(Boolean);
      this.cartHasGift = false;

      this.form = this.querySelector('form');
      this.fmt = (cents) => {
        const n = cents / 100;
        try {
          return new Intl.NumberFormat(cfg.locale || 'en', {
            style: 'currency',
            currency: cfg.currency,
            minimumFractionDigits: Number.isInteger(n) ? 0 : 2,
            maximumFractionDigits: 2
          }).format(n);
        } catch (e) {
          return '$' + n.toFixed(Number.isInteger(n) ? 0 : 2);
        }
      };

      this.buildFrequency();
      this.buildScents();
      this.buildPickGrid();
      this.bind();
      this.refreshCartState();
      this.render();
    }

    q(sel) { return this.querySelector(sel); }
    qa(sel) { return Array.from(this.querySelectorAll(sel)); }

    get variant() { return this.variants.find((v) => v.id === this.variantId); }
    get subUnit() {
      const v = this.variant;
      return v.allocs[this.planId] != null ? v.allocs[this.planId] : v.price;
    }
    get pct() {
      const v = this.variant;
      return v.price ? Math.round((1 - this.subUnit / v.price) * 100) : 0;
    }
    get giftType() {
      return this.subUnit * this.qty >= this.cfg.threshold ? 'pack' : 'small';
    }
    get gift() { return this.giftType === 'pack' ? this.cfg.sampleGift : this.cfg.smallGift; }
    get needsPicks() {
      return this.type === 'sub' && this.giftType === 'pack' && this.mode === 'custom' && this.picks.length < this.count;
    }

    swatchStyle(name, image) {
      if (image) return `background-image:url('${image}')`;
      const color = this.colors[String(name).toLowerCase()] || '#c4bfb8';
      return `--c:${color}`;
    }
    imageFor(name) {
      const v = this.variants.find((x) => x.scent.toLowerCase() === String(name).toLowerCase());
      return v ? v.image : null;
    }
    token(text) {
      return String(text)
        .replace(/\{pct\}/g, this.pct)
        .replace(/\{gift\}/g, this.fmt(this.gift.price));
    }

    /* ---------- builders ---------- */
    buildFrequency() {
      const wrap = this.q('[data-freq]');
      wrap.innerHTML = this.plans.map((p) => {
        const label = p.weeks ? `Every ${p.weeks} weeks` : esc(p.label);
        const pop = String(p.weeks) === String(this.cfg.popularWeeks) ? '<span class="lr-adv__pop">MOST POPULAR</span>' : '';
        return `<button type="button" data-plan-id="${p.id}">${pop}${label}</button>`;
      }).join('');
    }

    buildScents() {
      this.q('[data-scents]').innerHTML = this.variants.map((v) => {
        const badge = !v.available ? '<span class="lr-adv__badge-tag">SOLD OUT</span>'
          : v.seasonal ? '<span class="lr-adv__badge-tag">SEASONAL</span>' : '';
        const cls = v.image ? 'lr-adv__swatch lr-adv__swatch--img' : 'lr-adv__swatch';
        return `<button type="button" class="lr-adv__scent${v.available ? '' : ' is-out'}" data-variant="${v.id}"${v.available ? '' : ' disabled'} aria-pressed="false">
          <span class="${cls}" style="${this.swatchStyle(v.scent, v.image)}"></span>
          <span class="lr-adv__scent-name">${esc(v.scent)}</span>${badge}</button>`;
      }).join('');
    }

    buildPickGrid() {
      this.q('[data-pick-grid]').innerHTML = this.sampleOptions.map((name) => {
        const img = this.imageFor(name);
        return `<button type="button" class="lr-adv__pick" data-pick="${esc(name)}">
          <span class="lr-adv__swatch lr-adv__swatch--sm${img ? ' lr-adv__swatch--img' : ''}" style="${this.swatchStyle(name, img)}"></span>
          <span class="lr-adv__pick-name">${esc(name)}</span><span class="lr-adv__count" hidden></span></button>`;
      }).join('');
    }

    /* ---------- events ---------- */
    bind() {
      this.addEventListener('click', (e) => {
        const t = e.target.closest('button');
        if (!t || !this.contains(t)) return;

        if (t.dataset.plan) {
          if (t.dataset.plan === 'sub' && !this.hasPlans) return;
          this.type = t.dataset.plan;
        } else if (t.dataset.planId) {
          this.planId = Number(t.dataset.planId);
        } else if (t.dataset.variant) {
          this.variantId = Number(t.dataset.variant);
          this.announceVariant();
        } else if (t.dataset.mode) {
          this.mode = t.dataset.mode;
        } else if (t.dataset.pick !== undefined) {
          if (this.picks.length < this.count) this.picks.push(t.dataset.pick);
        } else if (t.dataset.slot !== undefined) {
          this.picks.splice(Number(t.dataset.slot), 1);
        } else if (t.hasAttribute('data-slot-clear')) {
          this.picks = [];
        } else if (t.dataset.qty) {
          this.qty = Math.max(1, this.qty + (t.dataset.qty === 'up' ? 1 : -1));
        } else {
          return;
        }
        this.render();
      });

      this.q('[data-lr-qty]').addEventListener('change', (e) => {
        this.qty = Math.max(1, parseInt(e.target.value, 10) || 1);
        this.render();
      });

      this.form.addEventListener('submit', (e) => this.prepareGift(e), true);
      window.addEventListener('pageshow', (e) => { if (e.persisted) this.refreshCartState(); });
    }

    announceVariant() {
      const v = this.variant;
      if (!v.mediaId) return;
      this.dispatchEvent(new CustomEvent('on:variant:change', {
        bubbles: true,
        detail: { form: this.form, variant: { id: v.id, featured_media: { id: v.mediaId } }, selectedOptions: [v.name] }
      }));
    }

    /* ---------- rendering ---------- */
    render() {
      const v = this.variant;
      const sub = this.type === 'sub';
      const gift = this.gift;
      const isPack = this.giftType === 'pack';
      const saving = v.price - this.subUnit;

      // price line, offer, plan cards
      this.q('[data-price-line]').innerHTML = this.hasPlans
        ? `From <b>${this.fmt(this.subUnit)}</b> with subscription · <span>${this.fmt(v.price)}</span> one-time`
        : `<b>${this.fmt(v.price)}</b>`;
      this.q('[data-offer]').hidden = !this.hasPlans;
      this.q('.lr-adv__plans').hidden = !this.hasPlans;
      this.q('[data-offer]').textContent = this.token(this.cfg.texts.offer);
      this.q('[data-save-tag]').textContent = `SAVE ${this.pct}%`;
      this.q('[data-sub-hint]').textContent = this.token(this.cfg.texts.subHint);
      this.q('[data-sub-compare]').textContent = this.fmt(v.price);
      this.q('[data-sub-price]').textContent = this.fmt(this.subUnit);
      this.q('[data-sub-saving]').textContent = `You save ${this.fmt(saving)}`;
      this.q('[data-once-price]').textContent = this.fmt(v.price);

      this.qa('[data-plan]').forEach((b) => {
        const on = b.dataset.plan === this.type;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on);
        if (b.dataset.plan === 'sub') b.hidden = !this.hasPlans;
      });
      this.qa('[data-sub-only]').forEach((el) => { el.hidden = !sub; });

      // delivery
      this.qa('[data-plan-id]').forEach((b) => b.classList.toggle('is-on', Number(b.dataset.planId) === this.planId));
      this.q('[data-perks]').innerHTML = lines(this.cfg.texts.perks).map((l) => `<li>${esc(this.token(l))}</li>`).join('');

      // scents
      this.qa('[data-variant]').forEach((b) => {
        const on = Number(b.dataset.variant) === this.variantId;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on);
      });
      this.q('[data-scent-name]').textContent = v.scent + (v.seasonal ? ' (seasonal)' : '');
      const notes = this.notes[v.scent.toLowerCase()];
      this.q('[data-scent-detail]').innerHTML =
        `<span class="lr-adv__swatch lr-adv__swatch--xs${v.image ? ' lr-adv__swatch--img' : ''}" style="${this.swatchStyle(v.scent, v.image)}"></span>` +
        `<div><b>${esc(v.scent)}</b>${notes ? `<div class="lr-adv__notes">${esc(notes)}</div>` : ''}</div>`;

      // gift blocks
      const packBox = this.q('[data-gift="pack"]');
      const smallBox = this.q('[data-gift="small"]');
      packBox.hidden = !isPack;
      smallBox.hidden = isPack;
      const cfg = this.cfg;
      this.q('[data-gift-rrp]').textContent = `${this.fmt(cfg.sampleGift.price)} RRP`;
      this.q('[data-gift-price]').textContent = this.fmt(cfg.sampleGift.price);
      this.q('[data-gift-title]').textContent = cfg.sampleGift.title;
      this.q('[data-gift-img]').innerHTML = cfg.sampleGift.image ? `<img src="${cfg.sampleGift.image}" alt="" loading="lazy">` : '';
      this.q('[data-small-rrp]').textContent = `${this.fmt(cfg.smallGift.price)} RRP`;
      this.q('[data-small-price]').textContent = this.fmt(cfg.smallGift.price);
      this.q('[data-small-title]').textContent = cfg.smallGift.title;
      this.q('[data-small-img]').innerHTML = cfg.smallGift.image ? `<img src="${cfg.smallGift.image}" alt="" loading="lazy">` : '';

      // sample picker
      const custom = this.mode === 'custom';
      this.qa('[data-mode]').forEach((b) => b.classList.toggle('is-on', b.dataset.mode === this.mode));
      this.q('[data-surprise-note]').hidden = custom;
      this.q('[data-surprise-note]').textContent = cfg.texts.surprise;
      this.q('[data-picks]').hidden = !custom;
      if (custom) this.renderSlots();

      // add to cart
      const atc = this.q('[data-atc]');
      const total = (sub ? this.subUnit : v.price) * this.qty;
      let label = `Add to cart – ${this.fmt(total)}`;
      let disabled = false;
      if (!v.available) { label = 'Sold out'; disabled = true; }
      else if (this.needsPicks) {
        const left = this.count - this.picks.length;
        label = `Choose ${left} more sample${left === 1 ? '' : 's'}`;
        disabled = true;
      }
      atc.disabled = disabled;
      atc.textContent = label;
      this.atcLabel = label;
      this.q('[data-lr-id]').value = v.id;
      this.q('[data-lr-plan]').value = sub && this.planId ? this.planId : '';
      this.q('[data-lr-qty]').value = this.qty;
      this.q('[data-reassure]').textContent = sub
        ? 'Free gift ships with your first order · Skip or cancel anytime'
        : (this.hasPlans ? `Switch to subscribe to save ${this.pct}% and get a free gift worth ${this.fmt(gift.price)}` : '');
    }

    renderSlots() {
      const slots = this.q('[data-slots]');
      let html = '';
      for (let i = 0; i < this.count; i++) {
        const name = this.picks[i];
        const img = name ? this.imageFor(name) : null;
        const next = i === this.picks.length;
        const style = name ? this.swatchStyle(name, img) : '';
        html += `<button type="button" class="lr-adv__slot${name ? ' is-filled' : ''}${next ? ' is-next' : ''}" data-slot="${i}"${name ? '' : ' disabled'}>
          <span class="lr-adv__tube${img ? ' lr-adv__swatch--img' : ''}" style="${style}">${name ? '' : i + 1}</span>
          <span class="lr-adv__slot-label">${name ? esc(name) : 'Pick a scent'}</span></button>`;
      }
      slots.innerHTML = html;
      slots.style.setProperty('--slots', this.count);

      const done = this.picks.length === this.count;
      const status = this.q('.lr-adv__slot-status');
      status.classList.toggle('is-done', done);
      this.q('[data-slot-count]').textContent = done
        ? `✓ All ${this.count} samples chosen`
        : `${this.picks.length} of ${this.count} chosen – tap a scent to add it`;

      const grid = this.q('[data-pick-grid]');
      grid.classList.toggle('is-full', done);
      this.qa('[data-pick]').forEach((b) => {
        const n = this.picks.filter((p) => p === b.dataset.pick).length;
        b.classList.toggle('is-in', n > 0);
        const badge = b.querySelector('.lr-adv__count');
        badge.hidden = n === 0;
        badge.textContent = n;
      });
    }

    /* ---------- cart ---------- */
    refreshCartState() {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(`${root}cart.js`, { credentials: 'same-origin' })
        .then((r) => r.json())
        .then((cart) => {
          this.cartHasGift = cart.items.some((i) => this.giftIds.includes(Number(i.variant_id)));
        })
        .catch(() => {});
    }

    prepareGift(event) {
      if (this.type !== 'sub' || this.cartHasGift || !this.planId) return;
      if (this.needsPicks) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      const gift = this.gift;
      if (!gift.variantId) return;

      const fields = [
        [this.q('[data-lr-id]'), 'id', 'items[0][id]'],
        [this.q('[data-lr-qty]'), 'quantity', 'items[0][quantity]'],
        [this.q('[data-lr-plan]'), 'selling_plan', 'items[0][selling_plan]']
      ];
      fields.forEach(([input, original, temp]) => { input.dataset.lrOriginalName = original; input.name = temp; });

      const extra = [
        ['items[1][id]', gift.variantId],
        ['items[1][quantity]', 1],
        ['items[1][properties][_lr_free_subscription_gift]', 'true']
      ];
      if (this.giftType === 'pack') {
        const chosen = this.mode === 'custom' ? this.picks : this.surprise;
        chosen.forEach((name, i) => extra.push([`items[1][properties][Sample ${i + 1}]`, name]));
      }
      const added = extra.map(([name, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        this.form.appendChild(input);
        return input;
      });

      this.cartHasGift = true;
      window.setTimeout(() => {
        fields.forEach(([input, original]) => { input.name = original; delete input.dataset.lrOriginalName; });
        added.forEach((input) => input.remove());
        window.setTimeout(() => this.refreshCartState(), 1200);
        // The theme swaps the button text while adding; put ours back afterwards.
        window.setTimeout(() => this.render(), 4300);
      }, 0);
    }
  }

  window.customElements.define('lr-adv-buybox', LrAdvBuybox);
})();

/* Gallery: one large image with a thumbnail row, plus keeping tall buy boxes in view. */
(function () {
  if (window.customElements.get('lr-adv-gallery')) return;

  class LrAdvGallery extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const data = this.querySelector('[data-lr-adv-media]');
      this.media = data ? JSON.parse(data.textContent) : [];
      this.main = this.querySelector('[data-main]');
      this.thumbs = this.querySelector('[data-thumbs]');
      this.wrap = this.querySelector('[data-thumbs-wrap]');
      const img = this.main.querySelector('img');
      const src = img ? img.getAttribute('src') : '';
      const found = this.media.findIndex((m) => m.large === src);
      this.index = found > -1 ? found : 0;

      this.thumbs.addEventListener('click', (e) => {
        const b = e.target.closest('[data-index]');
        if (b) this.show(Number(b.dataset.index));
      });
      this.wrap.addEventListener('click', (e) => {
        const nav = e.target.closest('[data-thumb-nav]');
        if (!nav) return;
        const dir = nav.dataset.thumbNav === 'next' ? 1 : -1;
        this.thumbs.scrollTo({ left: this.thumbs.scrollLeft + dir * this.thumbs.clientWidth * 0.8, behavior: 'smooth' });
      });
      this.thumbs.addEventListener('scroll', () => this.updateNav(), { passive: true });
      window.addEventListener('resize', () => this.updateNav());
      document.addEventListener('on:variant:change', (e) => {
        const id = e.detail && e.detail.variant && e.detail.variant.featured_media && e.detail.variant.featured_media.id;
        const i = this.media.findIndex((m) => m.id === id);
        if (i > -1) this.show(i);
      });
      this.renderThumbs();
      this.initSticky();
    }

    show(i) {
      const m = this.media[i];
      if (!m || i === this.index) return;
      this.index = i;
      this.main.innerHTML = `<img src="${m.large}" alt="${String(m.alt).replace(/"/g, '&quot;')}">`;
      this.markActive(true);
    }

    renderThumbs() {
      this.wrap.hidden = this.media.length < 2;
      this.thumbs.innerHTML = this.media.map((m, i) =>
        `<button type="button" data-index="${i}" aria-label="Show image ${i + 1}"><img src="${m.thumb}" alt=""></button>`
      ).join('');
      this.markActive(false);
    }

    markActive(scroll) {
      const buttons = Array.from(this.thumbs.children);
      buttons.forEach((b, i) => {
        const on = i === this.index;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-current', on ? 'true' : 'false');
      });
      const active = buttons[this.index];
      if (active) {
        const left = active.offsetLeft - this.thumbs.offsetLeft;
        const view = this.thumbs.clientWidth;
        if (left < this.thumbs.scrollLeft || left + active.offsetWidth > this.thumbs.scrollLeft + view) {
          this.thumbs.scrollTo({ left: left - (view - active.offsetWidth) / 2, behavior: scroll ? 'smooth' : 'auto' });
        }
      }
      this.updateNav();
    }

    updateNav() {
      const t = this.thumbs;
      const overflow = t.scrollWidth > t.clientWidth + 2;
      const prev = this.wrap.querySelector('[data-thumb-nav="prev"]');
      const next = this.wrap.querySelector('[data-thumb-nav="next"]');
      prev.hidden = !overflow || t.scrollLeft <= 2;
      next.hidden = !overflow || t.scrollLeft + t.clientWidth >= t.scrollWidth - 2;
    }

    initSticky() {
      // The gallery stays in view while the (taller) right-hand column scrolls past it.
      const root = this.closest('.lr-pdp');
      if (!root || !root.classList.contains('lr-pdp--sticky')) return;
      const update = () => {
        const nav = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--nav-height')) || 0;
        const top = Math.min(nav + 16, window.innerHeight - this.offsetHeight - 16);
        this.style.setProperty('--lr-sticky-top', `${top}px`);
      };
      update();
      if (window.ResizeObserver) new ResizeObserver(update).observe(this);
      window.addEventListener('resize', update);
    }
  }
  window.customElements.define('lr-adv-gallery', LrAdvGallery);
})();

/*
 * Keep the header cart count in step with the cart.
 * The Rebuy cart drawer changes the cart without telling the theme header, so the count
 * only caught up after a refresh. This runs on the advertorial page only (the script is
 * loaded by main-advertorial-pdp.liquid) and re-reads the cart after any cart write.
 */
(function () {
  if (window.lrAdvCartSync) return;
  window.lrAdvCartSync = true;

  const CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  let timer = null;

  const sync = () => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(`${root}cart.js`, { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((cart) => {
        const count = cart.item_count;
        document.querySelectorAll('#site-control .cart-icon--basket2').forEach((link) => {
          const badge = link.querySelector('div');
          if (badge) badge.textContent = count;
          const label = link.querySelector('.text-link');
          if (label) label.textContent = label.textContent.replace(/\s*\(\d+\)\s*$/, '') + (count > 0 ? ` (${count})` : '');
        });
      })
      .catch(() => {});
  };
  const schedule = () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(sync, 350);
  };

  const nativeFetch = window.fetch;
  window.fetch = function (input) {
    const request = nativeFetch.apply(this, arguments);
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      if (CART_WRITE.test(url)) request.then(schedule, () => {});
    } catch (e) { /* never break the page's own request */ }
    return request;
  };

  const nativeOpen = XMLHttpRequest.prototype.open;
  const nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.lrAdvUrl = String(url || '');
    return nativeOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (CART_WRITE.test(this.lrAdvUrl || '')) this.addEventListener('loadend', schedule);
    return nativeSend.apply(this, arguments);
  };
})();
